/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  TextField,
  Typography,
} from '@mui/material';
import SelectAddGroupForm from '../SelectAddGroupForm';

const RobotRegisterCard = ({
  id,
  name,
  edit,
  read,
  checked,
  serial,
  alias,
  groups,
  error,
  onChange,
  onCancel,
  onComplete,
  onBlur,
}) => {
  return (
    <Card>
      {!edit && (
        <CardActions>
          <Button varinat="outlined" size="small" onClick={onCancel}>
            취소
          </Button>
          <Button
            varinat="outlined"
            color="secondary"
            size="small"
            disabled={!serial || (error && error.serial)}
            onClick={onComplete}
          >
            완료
          </Button>
        </CardActions>
      )}
      <CardContent>
        {read && (
          <Checkbox
            name="item-check"
            defaultChecked={checked}
            checked={checked}
            onChange={onChange}
          />
        )}
        <Typography variant="subtitle2">로봇 시리얼</Typography>
        <TextField
          {...{
            name: 'serial-text-input',
            placeholder: '로봇 시리얼을 입력하세요.',
          }}
          disabled={edit || read}
          value={serial}
          onChange={onChange}
          onBlur={onBlur}
          error={!!(error && error.serial)}
          helperText={error && error.serial}
          margin="dense"
          fullWidth
          required
        />
        <Typography variant="subtitle2">로봇 별칭</Typography>
        <TextField
          {...{
            name: 'alias-text-input',
            placeholder: '로봇 별칭을 입력하세요.',
            maxLength: 15,
          }}
          disabled={read}
          value={alias}
          onChange={onChange}
          error={!!(error && error.alias)}
          helperText={error && error.alias}
          margin="dense"
          fullWidth
        />
        <SelectAddGroupForm
          itemKey={name}
          robotId={id}
          groups={groups || []}
          readOnly={read}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
};

export default RobotRegisterCard;
